/**
 * Created by xnr on 2020-03-31.
 */
import request from "../utils/fetch";
//不分页,角色详情
export function info(data) {
  return request({
    url: "/user/sys/company/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

//不分页,菜单列表
export function menuList(data, requestOptions) {
  return request({
    url: "/user/menu/list",
    method: "get",
    requestBody: "null",
    loading: true,
    params: data,
    skipGlobalError: requestOptions && requestOptions.skipGlobalError,
  });
}

//新增角色
export function add(data) {
  return request({
    url: "/role/add",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}
//不分页,角色列表
export function list(data) {
  return request({
    url: "/role/list",
    method: "get",
    requestBody: "null",
    loading: true,
    params: data,
  });
}

// 角色下拉
export function roleXiala(data) {
  return request({
    url: "/user/sys/company/customer/pullRoleList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

//分页,角色列表
export function rolelist(data) {
  return request({
    url: "/user/sys/company/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

export function findRole(data) {
  return request({
    url: "/user/sys/company/list/roleName",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

//角色场景列表
export function menulist(data) {
  return request({
    url: "/user/scene/menu/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

//新增角色
export function addRole(data) {
  return request({
    url: "/user/sys/company/add",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

//编辑角色
export function editRole(data) {
  return request({
    url: "/user/sys/company/update",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

//修改角色
export function update(data) {
  return request({
    url: "/role/update",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}
//修改菜单状态
export function updateStatus(data) {
  return request({
    url: "/role/updateStatus",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

//修改菜单状态
export function updateIf(data) {
  return request({
    url: "/role/updateIf",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}
//删除角色
export function deleteRole(data) {
  return request({
    url: "/role/delete",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

//删除角色
export function delRole(data) {
  return request({
    url: "/user/sys/company/delete",
    method: "DELETE",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
